import Link from "next/link";
import { FC, useMemo, useRef } from "react";
import { useRecoilValue } from "recoil";
import Container from "~/components/Container";
import Icon from "~/components/Icon";
import SectionTitle from "~/components/SectionTitle";
import Text from "~/components/Text";
import { Product } from "~/services/product";
import storeConfigAtom from "~/services/store-config/store-config.atom";
import ProductsSlider from "../../components/ProductsSlider";
import { useLazyQuery, useQuery } from "@apollo/client";
import {
  GET_PRODUCTS_TRACKING,
  QUERY_TRACK_VIEW_COLLECTION,
  QUERY_TRACK_VIEW_ITEM_RELATED,
  QUERY_TRACKING_IMPRESSION,
  QUERY_TRACKING_VIEW_RELATED,
} from "~/data/product/gql";
import useClient from "~/hooks/useClient";

interface BestSellerProps {
  title?: string;
  directLabel?: string;
  directUrl?: string;
  loading?: boolean;
  numberOfItems?: number;
  numberOfRows?: number;
  data?: Product[];
  bestSellerRelatedProductsBySkus?: any;
  isMobile?: boolean;
}

const BestSeller: FC<BestSellerProps> = ({
  title = "BEST SELLER",
  directLabel = "",
  directUrl = "",
  bestSellerRelatedProductsBySkus,
  isMobile,
}) => {
  const isClient = useClient();
  const { best_seller_group_id } = useRecoilValue(storeConfigAtom?.store);
  const bestSellerGroupId =
    bestSellerRelatedProductsBySkus?.id ?? best_seller_group_id;
  const areRef = useRef<HTMLDivElement>(null);

  const [queryTrackViewItemRelated] = useLazyQuery(
    QUERY_TRACK_VIEW_ITEM_RELATED
  );

  const [queryTrackingViewList] = useLazyQuery(QUERY_TRACKING_VIEW_RELATED);
  const [queryTrackingViewCollection] = useLazyQuery(
    QUERY_TRACK_VIEW_COLLECTION
  );

  const [relatedTrackingImpression] = useLazyQuery(QUERY_TRACKING_IMPRESSION);

  const { data: dataCollectionTracking, loading: loadingCollectionTracking } =
    useQuery(GET_PRODUCTS_TRACKING, {
      variables: {
        skus: bestSellerRelatedProductsBySkus?.items?.map(
          (product: Product) => product.sku + ""
        ),
      },
      context: { fetchOptions: { method: "GET" } },
      skip:
        !bestSellerRelatedProductsBySkus?.items ||
        !bestSellerRelatedProductsBySkus?.items.length,
    });

  const _list = useMemo(() => {
    if (loadingCollectionTracking || !dataCollectionTracking)
      return bestSellerRelatedProductsBySkus?.items || [];
    return (bestSellerRelatedProductsBySkus?.items || []).map(
      (product: Product) => {
        const tracking = dataCollectionTracking?.productsBySkus?.items?.find(
          (item: any) => item.sku === product.sku
        );
        return {
          ...product,
          ...tracking,
        };
      }
    );
  }, [
    loadingCollectionTracking,
    dataCollectionTracking,
    bestSellerRelatedProductsBySkus,
  ]);

  // const { products, loading, relatedProductsBySkus } = useProductRelatedBySkus({
  //     ruleId: best_seller_group_id,
  //     limit: 48,
  //     position: RelatedPosition.HomePage,
  //     skip: !startFetching
  // });

  // const handleStartFetching = (entries: IntersectionObserverEntry) => {
  //     setStartFetching(true);
  // };

  const handleOnEnter = () => {
    console.log("queryTrackingViewList", bestSellerGroupId);
    queryTrackingViewList({
      variables: {
        block_id: bestSellerGroupId,
      },
    });
    queryTrackingViewCollection({
      variables: {
        block_id: bestSellerGroupId,
        type: "related",
      },
    });
  };

  const handleImpression = (products: any[]) => {
    console.log("handleImpressionBestSeller", bestSellerGroupId, products);
    queryTrackViewItemRelated({
      variables: {
        block_id: bestSellerGroupId,
        skus: products?.map((prod) => prod?.sku),
      },
    });
    relatedTrackingImpression({
      variables: {
        skus: products?.map((prod) => prod?.sku),
        block_id: bestSellerGroupId,
        type: "related",
        search_query: "",
      },
    });
  };

  // if (!products?.length && !loading && !!startFetching) {
  //     return null;
  // }
  // if (!best_seller_group_id) return null;

  // if (!isClient) {
  //     return null;
  // }

  return (
    <Container className="flex flex-col gap-2 lg:gap-2">
      <div ref={areRef} className="transform transition-all duration-500">
        <SectionTitle
          text={bestSellerRelatedProductsBySkus?.block_title ?? title}
          action={
            directUrl ? (
              <Link
                href={directUrl}
                className="flex items-center gap-1 text-primary"
              >
                <Text type="title-2">{directLabel}</Text>
                <Icon name="arrow-up-right" />
              </Link>
            ) : undefined
          }
        />

        <ProductsSlider
          listkey={bestSellerGroupId ?? bestSellerRelatedProductsBySkus?.id}
          products={_list}
          hasNext={false}
          loading={false}
          // onLoadingMore={() => handleFetchMore(_PageInfo.current_page + 1)}
          // onBeforeIntersection={handleStartFetching}
          onEnter={handleOnEnter}
          onImpressions={handleImpression}
          isMobile={isMobile}

          // loading={loading}
        />
      </div>
    </Container>
  );
};

export default BestSeller;
